// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_TodosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/links/todos
 *
 * Returns the dashboard-style list of payment links across the user's
 * franchises, enriched with `valor` (reais) and `payment_method_label`.
 * Per-row shape mirrors payment_links + enrichment and is owned downstream.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsLinks_TodosResponseDados = unknown[];

export type SubaccountsLinks_TodosResponse = ApiResponse<SubaccountsLinks_TodosResponseDados>;

registerResponseContract('SubaccountsLinks_TodosResponse', {})
